module.exports = "<app-mobile-bottombar>\r\n</app-mobile-bottombar>\r\n"